<!--
 * @Description: 账户信息展示界面
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-12 18:26:10
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div :class="'bizcomp-acct-info bizcomp ' + className">
        <!-- 头部信息 -->
        <div class="acc-info-head-contain">
            <div class="acc-info-img-name">
                <div class="act-img">
                    <img v-if="info.headimage" :src="$util.fileDownloadPath(info.headimage)" />
                    <img v-else :src="require('../../assets/img/account-img.png')" />
                    <el-upload
                        :action="$util.fileUploadPath('/sale-mid-ump/file/cmsUpload')"
                        :data="$util.fileUploadParam('10')"
                        :headers="$util.fileUploadHeader()"
                        :before-upload="uploadBefore"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :show-file-list="false"
                    >
                        <span class="img-btn">编辑</span>
                    </el-upload>
                </div>

                <div class="acc-info-name-div">
                    <div class="acc-info-name">
                        {{ info.custname }}
                    </div>
                    <div class="acc-info-time">上次登录：{{ info.lastlogintime }}</div>
                </div>
            </div>
            <div class="acc-info-score-risk">
                <!-- <div class="acc-info-score">
                    <template v-if="otherInfo.lucre">
                        积分：
                        <span class="color-e60012 font-16">{{ otherInfo.lucre }}</span>
                    </template>
                </div> -->
                <div class="acc-info-risk">
                    风险等级：
                    <span v-if="info.risklevel" class="color-e60012 font-16">
                        {{ $cache.getDict("100017", info.risklevel) }}
                    </span>
                </div>
            </div>
        </div>
        <!-- 基本信息 -->
        <div class="basic-info-contain">
            <div class="basic-info-head head-contain">
                <div class="basic-info">
                    <div class="basic-info-bar"></div>
                    <div class="basic-info-title">基本信息</div>
                </div>
                <div
                    v-if="$util.getBusinessModule('0B1')"
                    class="color-e60012 cursor-pointer"
                    v-on:click="modifyInfoFn"
                >
                    修改
                </div>
            </div>
            <div>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">基金账号</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        {{ info.taaccountid }}
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">姓名</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        {{ info.custname }}
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">国籍</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="info.nationality" class="flex-space-between">
                            <div>
                                {{ $cache.getDict("120109", info.nationality) }}
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">性别</el-col>
                    <el-col v-if="info.sex" :span="16" class="el-col-padding-left">
                        {{ $cache.getDict("110059", info.sex) }}
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">职业</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="info.vocationcode" class="flex-space-between">
                            <div>
                                {{ $cache.getDict("150141", info.vocationcode) }}
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">开户证件</el-col>
                    <el-col v-if="info.certificatetype" :span="16" class="el-col-padding-left">
                        {{
                            $cache.getDict("130007", info.certificatetype) +
                            " " +
                            info.certificateno
                        }}
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">证件有效期</el-col>
                    <el-col :span="16" class="el-col-padding-left certificate-contain-main">
                        <div class="certificate-contain">
                            <span>
                                {{
                                    info.validtype == "1" || info.validdate == "长期有效"
                                        ? "9999-12-31"
                                        : $util.fmtDate(info.validdate)
                                }}
                            </span>
                            <div v-if="warnExpire" class="certificate-warn-expire">
                                <img src="../../assets/img/warn-expire.png" alt="" />
                                <span class="certificate-warn-expire-text">即将到期</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">手机号码</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div class="flex-space-between">
                            <div>{{ info.mobileno }}</div>
                        </div>
                    </el-col>
                </el-row>

                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">联系地址</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="addressInfo" class="flex-space-between">
                            <div>
                                {{ addressInfo }}
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">电子邮件</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div class="flex-space-between">
                            <div>{{ info.email }}</div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">账户控制人</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="info.actualisself" class="flex-space-between">
                            <div>
                                {{ $cache.getDict("120137", info.actualisself) }}
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">账户受益人</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="info.benefisself" class="flex-space-between">
                            <div>
                                {{ $cache.getDict("120137", info.benefisself) }}
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- 风险测评 -->
        <div class="basic-info-contain">
            <div class="basic-info-head">
                <div class="basic-info-bar"></div>
                <div class="basic-info-title">风险测评</div>
            </div>
            <div v-if="$cache.getParams()['1000056']['paramvalue']">
                <el-row class="risk-tolerance-contain">
                    <el-col :span="8" class="risk-tolerance-border el-col-padding-left">
                        公募-风险承受能力
                    </el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div class="flex-space-between">
                            <div>
                                <div v-if="risklevel2">
                                    {{ $cache.getDict("100017", risklevel2) }}
                                    <span v-if="expired2FlghShow" class="expiredTip">已过期</span>
                                </div>
                                <div v-if="risklevel2" class="color-666666">
                                    根据适当性匹配规则，{{ getMatchedProduct(risklevel) }}
                                </div>
                            </div>
                            <div class="color-e60012 cursor-pointer" v-on:click="toRisk('2')">
                                重新测评
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="risk-tolerance-contain">
                    <el-col :span="8" class="risk-tolerance-border el-col-padding-left">
                        专户-风险承受能力
                    </el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div class="flex-space-between">
                            <div>
                                <div v-if="risklevel3">
                                    {{ $cache.getDict("100017", risklevel3) }}
                                    <span v-if="expired3FlghShow" class="expiredTip">已过期</span>
                                </div>
                                <div v-if="risklevel3" class="color-666666">
                                    根据适当性匹配规则，{{ getMatchedProduct(risklevel) }}
                                </div>
                            </div>
                            <div class="color-e60012 cursor-pointer" v-on:click="toRisk('3')">
                                重新测评
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div v-else>
                <el-row class="risk-tolerance-contain">
                    <el-col :span="8" class="risk-tolerance-border el-col-padding-left">
                        风险承受能力
                    </el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div class="flex-space-between">
                            <div>
                                <div v-if="risklevel">
                                    {{ $cache.getDict("100017", risklevel) }}
                                    <span v-if="expiredFlghShow" class="expiredTip">已过期</span>
                                </div>
                                <div v-if="risklevel" class="color-666666">
                                    根据适当性匹配规则，{{ getMatchedProduct(risklevel) }}
                                </div>
                            </div>
                            <div class="color-e60012 cursor-pointer" v-on:click="toRisk()">
                                重新测评
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 更多信息 -->
        <div class="basic-info-contain">
            <div class="basic-info-head">
                <div class="basic-info-bar"></div>
                <div class="basic-info-title">更多信息</div>
            </div>
            <div>
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">投资者级别</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="info.professionflag" class="flex-space-between">
                            <div>
                                {{ $cache.getDict("120051", info.professionflag) }}
                            </div>
                            <div
                                v-if="allowTransform"
                                class="color-e60012 cursor-pointer"
                                v-on:click="invChange"
                            >
                                转换
                            </div>
                            <div v-else class="color-e60012 cursor-pointer" v-on:click="invDetail">
                                了解详情
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <!-- <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">诚信记录</el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="info.creditlevel">
                            {{ $cache.getDict("24052002", info.creditlevel) }}
                        </div>
                    </el-col>
                </el-row> -->
                <el-row class="el-row-common">
                    <el-col :span="8" class="el-col-border el-col-padding-left">
                        税收身份证明
                    </el-col>
                    <el-col :span="16" class="el-col-padding-left">
                        <div v-if="info.nonresiflag" class="flex-space-between">
                            <div>
                                {{ $cache.getDict("120043", info.nonresiflag) }}
                            </div>
                            <div class="color-e60012 cursor-pointer" v-on:click="taxesList">
                                详情
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <!-- <el-row class="save-money-to-purchase">
                    <el-col :span="8" class="save-money-to-purchase-border el-col-padding-left">
                        省钱购
                    </el-col>
                    <el-col v-show="true" :span="16" class="el-col-padding-left">
                        <div class="flex-space-between">
                            <div>
                                <div>已{{ info.custtag == "1" ? "开启" : "关闭" }}省钱购服务</div>
                                <div style="display: flex; align-items: center">
                                    <img src="../../assets/img/warn-expire.png" alt="" />

                                    <div class="save-money-to-purchase-text">
                                        开启即代表阅读并同意
                                        <span
                                            class="save-money-to-purchase-protocol"
                                            v-on:click="openFile"
                                        >
                                            《省钱购服务协议》
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="color-e60012 cursor-pointer" v-on:click="opCustTag">
                                {{ info.custtag == "1" ? "关闭" : "开启" }}
                            </div>
                        </div>
                    </el-col>
                </el-row> -->
            </div>
        </div>
        <pdf-popup
            base64
            :visible="pdfVisible"
            :need-time="false"
            :read-file-info-list="currentFileInfoList"
            v-on:close="pdfVisibleOk"
        ></pdf-popup>
        <my-dialog
            :title="agrData.title"
            :visible.sync="agrVisible"
            :dialog-close="agrVisibleHide"
            width="800px"
        >
            <div class="protocol-detail" v-html="agrData.content"></div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="agrVisibleOk">
                    确定
                </el-button>
            </div>
        </my-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import PdfPopup from "@/components/util/pdfPopup";
import myDialog from "@/components/layout/myDialog.vue";
import commonApi from "@/api/common";
import fundApi from "@/api/fund";
import { sceneEnum } from "@/util/util_jfit";

export default {
    name: "AcctInfo",
    components: { PdfPopup, myDialog },
    mixins: [mixin],
    data() {
        return {
            headimage: "",
            uploadFlag: true,
            info: {},
            cityListObj: this.$cache.get("address")["citylists"] || {},
            countyListObj: this.$cache.get("address")["countylists"] || {},
            // riskProInfo: [
            //     "低风险",
            //     "低风险",
            //     "低风险、中低风险",
            //     "低风险、中低风险、中风险",
            //     "低风险、中低风险、中风险、中高风险",
            //     "低风险、中低风险、中风险、中高风险、高风险"
            // ],
            otherInfo: {},
            pdfVisible: false,
            agrVisible: false,
            agrData: {},
            currentFileInfoList: [],
            lowriskCanBuy: false,
            risklevel: "", // 公用
            risklevel2: "",
            risklevel3: "",
            phydate: "", // 当前物理时间
            expiredFlghShow: "", // 风险测评是否过期
            expired2FlghShow: "", // 公募测评是否过期
            expired3FlghShow: "", // 专户测评是否过期
            allowTransform: false // 是否允许投资者转换
        };
    },
    computed: {
        addressInfo() {
            if (
                this.info.livingaddressprovince ||
                this.info.livingaddresscity ||
                this.info.livingaddresscounty
            ) {
                return (
                    this.$cache.getDict("190021", this.info.livingaddressprovince) +
                    this.$cache.getDict("190022", this.info.livingaddresscity) +
                    this.$cache.getDict("190023", this.info.livingaddresscounty) +
                    this.info.livingaddress
                );
            } else {
                return "";
            }
        },
        warnExpire() {
            if (
                this.info.validtype == "1" ||
                this.info.validdate == "长期有效" ||
                this.info.validdate == "99991231"
            ) {
                return false;
            } else {
                if (this.info.validdate) {
                    const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
                    const startDate = new Date(this.$util.fmtDate(this.info.validdate));
                    const endDate = new Date();
                    const differenceInDays = Math.round(Math.abs((startDate - endDate) / oneDay));
                    return differenceInDays <= 30;
                } else {
                    return false;
                }
            }
        }
    },
    mounted() {
        this.allowTransform = this.$cache.getCompanyInfoParam("10105010") == "1";
        this.lowriskCanBuy = this.$cache.getCompanyInfoParam("6000016") !== "1"; // 命中最低风测答案风险等级为0无风险,选否则可以购买R1
        this.$cache.refreshUser(() => {
            this.getUserInfo();
            this.getAgreement();
            this.getRisklevel();
        });
    },
    methods: {
        getMatchedProduct(risklevel) {
            if (risklevel === "0") {
                return this.lowriskCanBuy
                    ? "您适合投资低风险产品（不允许购买风险错配产品）"
                    : "您禁止购买任意产品";
            }
            let productRisk = this.$cache.getDict("110143");
            let matchedRisk = productRisk.filter((item) => item.subitem <= risklevel);
            let res = "";
            matchedRisk.forEach((item) => (res += item.subitemname + "风险、"));
            return "您适合投资" + res.substring(0, res.length - 1) + "产品";
        },
        async getRisklevel() {
            let assettype = this.$util.getParamValue("1000056");
            const info = this.$cache.getUser();
            this.phydate = info.phydate;
            if (assettype) {
                const res2 = await userApi.acctRiskinfoQuery({
                    assettype: assettype.indexOf("2") > -1 ? "2" : "*"
                });
                this.risklevel2 = res2 && res2.data && res2.data.custrisk;
                this.expired2FlghShow = this.phydate > (res2 && res2.data && res2.data.riskenddate);
                const res3 = await userApi.acctRiskinfoQuery({
                    assettype: assettype.indexOf("3") > -1 ? "3" : "*"
                });
                this.risklevel3 = res3 && res3.data && res3.data.custrisk;
                this.expired3FlghShow = this.phydate > (res3 && res3.data && res3.data.riskenddate);
            } else {
                const res = await userApi.acctRiskinfoQuery({
                    assettype: "*"
                });
                this.risklevel = res && res.data && res.data.custrisk;
                this.expiredFlghShow = this.phydate > (res && res.data && res.data.riskenddate);
            }
        },
        openFile() {
            if (this.agrData.fileid == null || !this.agrData.fileid) {
                this.agrVisible = true;
            } else {
                this.pdfVisible = true;
            }
        },
        pdfVisibleOk() {
            commonApi.agreementLeaveTracesLog(
                this,
                {
                    eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/s",
                    eventname: `协议同意`
                },
                this.currentFileInfoList
            );
            this.pdfVisible = false;
        },
        agrVisibleHide() {
            this.agrVisible = false;
        },
        agrVisibleOk() {
            commonApi.agreementLeaveTracesLog(
                this,
                {
                    eventid: this.$const.RECORD.cms_protocol_agreement_agree,
                    eventname: `协议同意`
                },
                this.currentFileInfoList
            );
            this.agrVisible = false;
        },
        getAgreement() {
            // 省钱购
            this.$util.getProtocol(sceneEnum.budgetBuy).then((res) => {
                if (res[0]) {
                    res[0].filename = res[0].title;
                    this.agrData = res[0];
                    this.currentFileInfoList = [res[0]];
                }
            });
        },
        async opCustTag() {
            const custtag = this.info.custtag == "1" ? "0" : "1";
            this.$util.opCustTag(custtag, this.info, () => {
                this.$message({
                    type: "success",
                    message: "省钱购开关已更新成功！"
                });
            });
        },
        async getUserInfo() {
            const _this = this;
            this.info = await this.$cache.getUser();
            this.info.headimage = this.$cache.getHeadImage();
            this.$util.getProfession((data) => {
                _this.info = Object.assign(
                    {},
                    _this.info,
                    data,
                    _this.$cache.getIsEncrypted()
                        ? {
                              custname: this.$cache.getUser().custname
                          }
                        : {}
                );
            });
            const otherUserInfo = this.$cache.getUserOtherInfo();
            this.info.lastlogintime =
                otherUserInfo.lastlogintime == "--"
                    ? otherUserInfo.lastlogintime
                    : otherUserInfo.lastlogintime
                    ? otherUserInfo.lastlogintime.replace(
                          /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
                          "$1-$2-$3 $4:$5:$6"
                      )
                    : this.info.lastlogintime.replace(
                          /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
                          "$1-$2-$3 $4:$5:$6"
                      );
            if (otherUserInfo && otherUserInfo.custnoCrm) {
                const res = await userApi.qryCrmCustInfo({
                    custnoCrm: otherUserInfo.custnoCrm
                });
                this.otherInfo = res.data;
            }
        },
        modifyInfoFn() {
            this.$router.push({ name: "modifyinfo" });
        },
        async toRisk(assettype) {
            let assetType = this.$util.getParamValue("1000056");
            const res = await userApi.checkRiskInfo({
                custno: this.info.custno,
                assettype: assetType.indexOf(assettype) > -1 ? assettype : "*"
            });
            let checkRiskInfo = res.data;
            if (this.expired2FlghShow && assettype == "2") {
                this.$router.push({
                    name: "risktest",
                    query: {
                        firstriskdayflag: checkRiskInfo.firstriskdayflag,
                        assettype,
                        risklevel: this.risklevel2
                    }
                });
            } else if (this.expired3FlghShow && assettype == "3") {
                this.$router.push({
                    name: "risktest",
                    query: {
                        firstriskdayflag: checkRiskInfo.firstriskdayflag,
                        assettype: assettype,
                        risklevel: this.risklevel3
                    }
                });
            } else {
                this.$router.push({
                    name: "risk",
                    query: {
                        assettype,
                        risklevel: assettype ? this["risklevel" + assettype] : this["risklevel"]
                    }
                });
            }
        },
        invChange() {
            this.$router.push({ name: "invchange" });
        },
        invDetail() {
            this.$router.push({ name: "invdetail" });
        },
        taxesList() {
            this.$router.push({ name: "taxeslist" });
        },
        uploadBefore(file) {
            let maxSize = "3";
            if (file.size > 1024 * 1024 * maxSize) {
                this.headimage = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return false;
            }
        },
        uploadError(err, file, fileList) {
            this.$message.warning(err);
        },
        async uploadSuccess(response, file, fileList) {
            const res = await userApi.modifyAcctExt({
                headimage: response.data.id
            });
            if (res.code == "0") {
                const info = this.$cache.getUser();
                info.headimage = response.data.id;
                this.$cache.setHeadImage(response.data.id);
                this.$store.dispatch("setInfo", info);
                this.info.headimage = response.data.id;
            }
        },
        upHeaderImg(file) {
            setTimeout(async () => {
                const res = await userApi.cmsUpload({ file: file });
            }, 200);
        }
    }
};
</script>
<style lang="scss" scoped>
/* 用户信息 */
.bizcomp-acct-info {
    .acc-info-head-contain {
        display: flex;
        padding: 25px 16px;
        height: 120px;
        border-radius: 6px;
        background: linear-gradient(180deg, var(--color-accent) 0%, var(--color-accent) 100%);
        box-sizing: border-box;
        .acc-info-img-name {
            display: flex;
            width: 369px;
            .act-img {
                position: relative;
                margin-left: 16px;
                width: 65px;
                height: 65px;
                float: left;
                border-radius: 100% 100%;
                -webkit-border-radius: 100% 100%;
                overflow: hidden;
                img {
                    width: 65px;
                    height: 65px;
                    border-radius: 50%;
                    border: 1px solid var(--color-border-base);
                    box-sizing: border-box;
                }
                .img-btn {
                    position: absolute;
                    bottom: 0px;
                    line-height: 24px;
                    z-index: 100;
                    width: 100%;
                    left: 0;
                    cursor: pointer;
                    text-align: center;
                    color: #ffffff;
                    font-size: 12px;
                    background-color: rgba(0, 0, 0, 0.3);
                    display: none;
                }
                &:hover .img-btn {
                    display: block;
                }
                .el-input {
                    position: absolute;
                    bottom: 0px;
                    right: 0px;
                    z-index: 101;
                    opacity: 0;
                }
            }
            .acc-info-name-div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 10px;
                .acc-info-name {
                    font-size: 20px;
                    font-weight: bold;
                    color: var(--color-text-primary);
                }
                .acc-info-time {
                    margin-top: 12px;
                    font-size: 14px;
                    font-weight: normal;
                    color: var(--color-text-regular);
                }
            }
        }
        .acc-info-score-risk {
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 14px;
            .acc-info-score {
                height: 17.78px;
            }
            .acc-info-risk {
                margin-top: 20px;
            }
        }
    }
    .basic-info-contain {
        margin-top: 20px;
        border: 1px solid var(--color-divided);
        box-sizing: border-box;
        .head-contain {
            display: flex;
            justify-content: space-between;
            padding-right: 16px;
            .basic-info {
                background: var(--color-bg-container);
                display: flex;
                align-items: center;
            }
        }
        .basic-info-head {
            height: 60px;
            background: var(--color-bg-container);
            display: flex;
            align-items: center;
            padding-left: 16px;

            .basic-info-bar {
                width: 4.68px;
                height: 16px;
                background: var(--color-primary);
            }
            .basic-info-title {
                margin-left: 6px;
                font-size: 18px;
                font-weight: bold;
                color: var(--color-text-primary);
            }
        }
        .certificate-contain-main {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .certificate-contain {
            display: flex;
            align-items: center;
            .certificate-warn-expire {
                display: flex;
                align-items: center;
                margin-left: 20px;
                .certificate-warn-expire-text {
                    margin-left: 6px;
                    color: var(--color-primary);
                }
            }
        }
        .el-row-common {
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid var(--color-border-base);
            display: flex;
            align-items: center;
            color: var(--color-text-primary);
        }
        .save-money-to-purchase,
        .risk-tolerance-contain {
            border-bottom: 1px solid var(--color-border-base);
            display: flex;
            align-items: center;
            color: var(--color-text-primary);
            height: 80px;
            .save-money-to-purchase-text {
                margin-left: 10px;
                color: var(--color-text-accent);
            }
            .save-money-to-purchase-protocol {
                color: var(--color-primary);
                cursor: pointer;
            }
        }
        .el-col-border {
            font-weight: bold;
            border-right: 1px solid var(--color-border-base);
        }
        .save-money-to-purchase-border,
        .risk-tolerance-border {
            height: 80px;
            line-height: 80px;
            font-weight: bold;
            border-right: 1px solid var(--color-border-base);
        }
        .el-col-padding-left {
            padding: 0 16px;
        }
    }
    .protocol-detail {
        padding: 20px 10px;
        max-height: 80vh;
        min-height: 10vh;
        overflow: scroll;
    }
    .flex-space-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .expiredTip {
            margin-left: 10px;
            color: var(--color-primary);
        }
    }
    .color-e60012 {
        color: var(--color-primary);
    }
    .color-666666 {
        color: var(--color-text-regular);
    }
    .font-16 {
        font-size: 16px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
}
</style>
